import { type Directive, type DirectiveBinding } from 'vue'

import { cleanTranslation } from '@/utils/common'

export type CleanHtmlDirective = Directive<HTMLElement, string>

declare module 'vue' {
  export interface GlobalDirectives {
    vCleanHtml: CleanHtmlDirective
  }
}

// eslint-disable-next-line func-style
const directive: CleanHtmlDirective = (el: Element, binding: DirectiveBinding<string>) => {
  el.innerHTML = cleanTranslation(binding.value)
}

export default directive
